<div class="footer">
  <div class="copyright"><span>&copy;</span> {{ year }} TimeWarp — All Rights Reserved</div>
  <div class="links">
    <router-link to="/">Home</router-link>
    <router-link to="/pools">Pools</router-link>
    <a href="https://docs.timewarp.finance" target="_blank">Docs</a>
  </div>
</div>
